import React, { useState, useRef, useEffect } from "react";
import { Pressable, Text, Menu, useMediaQuery, Box, HStack } from "native-base";
import { COLORS } from "../../utils/colors";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { COMMONFONTSIZE } from "../../utils/fonts";
import Svg from "react-native-svg";
import { attachmentFileSVG, downloadIconSVG } from "../../utils/svg";
import CustomModal from "../modal";
import MobileModelSheet from "../actionSheet";
import FileViewerComponent from "../fileViewer";
import ImageViewerJs from "../imageViewer/viewer";
import config from "../../utils/config";
import { setIsDownloading } from "../../store/reducers/eventSlice";
import { useDispatch } from "react-redux";

const DocumentList = ({ people }) => {
  const dispatch = useDispatch();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [showModal, setShowModal] = useState(false);
  const extension = ["png", "jpg", "jpeg"];
  const [selected, setSelected] = useState("");
  const menuRef = useRef(null);

  const openModal = (item) => {
    setSelected(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getModalChildren = () => {
    const extension = selected.file_name.split(".").pop();
    return extension === "png" ||
      extension === "jpeg" ||
      extension === "jpg" ? (
      <></>
    ) : (
      <Box>
        <FileViewerComponent
          path={config.bucketPath + selected.file_name}
          height="68vh"
        />
      </Box>
    );
  };

  const getModalHeader = () => {
    return (
      <HStack
        justifyContent={"space-between"}
        width={MobileWindow ? "90%" : "95%"}
      >
        <Text width={MobileWindow && "100%"}>{selected.doc_type}</Text>
        <Pressable
          onPress={() => {
            dispatch(setIsDownloading(true));
            const parts = selected.file_name.split("_");
            const filename = parts.slice(1).join("_").trim();
            const sanitizedFilename = decodeURIComponent(filename).replace(
              /^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g,
              ""
            );

            fetch(config.bucketPath + selected.file_name)
              .then((response) => response.blob())
              .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = sanitizedFilename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
              })
              .catch((error) => {
                console.error("Error downloading file:", error);
              });
              dispatch(setIsDownloading(false));
          }}
        >
          <Box mt={MobileWindow && 1}>
            {/* <i
              className="fa fa-download pointer"2 Docu
              style={{ color: "black" }}
            ></i> */}
            <Svg width="50" height="40" viewBox={"12 0 1 36"}>
              {downloadIconSVG}
            </Svg>
          </Box>
        </Pressable>
      </HStack>
    );
  };

  return (
    <>
      {showModal && !MobileWindow ? (
        <CustomModal
          size=""
          top={"20px"}
          isOpen={showModal}
          onClose={closeModal}
          header={getModalHeader()}
          body={showModal && getModalChildren()}
          width={
            extension.includes(selected?.file_name.split(".").pop())
              ? "fit-content"
              : "auto"
          }
          height={
            extension.includes(selected?.file_name.split(".").pop())
              ? "fit-content"
              : "90vh"
          }
          fixedPosition={true}
        />
      ) : (
        <MobileModelSheet
          isOpen={showModal}
          onClose={closeModal}
          header={getModalHeader()}
          body={showModal && getModalChildren()}
          maxH={"80vh"}
          position="hidden"
        />
      )}
      <Menu
        ref={menuRef}
        placement="bottom right"
        trigger={(triggerProps) => {
          return (
            <Pressable {...triggerProps} justifyContent={"center"}>
              <Text color={COLORS.TABS_ACTIVE_BORDER_COLOR}>
                {people.boarding_pass_path.length} Documents
              </Text>
            </Pressable>
          );
        }}
        mx={"2%"}
        w={380}
      >
        {people.boarding_pass_path.map((item) => {
          return (
            <Menu.Item
              key={item.id}
              w={380}
              fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
              color={COLORS.TABS_ACTIVE_BORDER_COLOR}
              onPress={() => {
                const extension = item.file_name.split(".").pop();
                if (
                  extension === "png" ||
                  extension === "jpeg" ||
                  extension === "jpg"
                ) {
                } else openModal(item);
              }}
            >
              <HStack alignItems="center" space={2} w={"100%"}>
                <Box width={MobileWindow ? "10%" : "25px"}>
                  <Svg width="35" height="35" viewBox="0 200 1060 600">
                    {attachmentFileSVG}
                  </Svg>
                </Box>
                {item.file_name.split(".").pop() === "png" ||
                item.file_name.split(".").pop() === "jpeg" ||
                item.file_name.split(".").pop() === "jpg" ? (
                  <ImageViewerJs
                    text={item.doc_type}
                    destroy={false}
                    src={config.bucketPath + item.file_name}
                    width="100%"
                  />
                ) : (
                  <HStack
                    justifyContent={"space-between"}
                    w={MobileWindow ? "87.5%" : "90%"}
                  >
                    <Text wordBreak="break-all">{item.doc_type}</Text>
                    {/* <i className="fa fa-download pointer"></i> */}
                    <Svg width="50" height="40" viewBox={"12 0 1 36"}>
                      {downloadIconSVG}
                    </Svg>
                  </HStack>
                )}
              </HStack>
            </Menu.Item>
          );
        })}
      </Menu>
    </>
  );
};

export default DocumentList;
